import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import { Actions, ActionTypes } from '../../store/applicationsettings/applicationsettings.actions';
import { StateInterface } from '../../store/state.model';
import { HeadersHelper, ItemsHelper } from '../../helpers';
import { getState, tassign } from '../../tools';

import 'rxjs/Rx';

@Injectable()

/**
 * Class representing the applicationsettings service.
 */
export class ApplicationSettingsService {
	/**
	 * Constructor.
	 * @param {string} apiEndPoint
	 * @param {Http} http
	 * @param {Store} store
	 * @return {void}
	 */
	constructor(
		@Inject('ApiEndpoint') private apiEndpoint: string,
		private http: Http,
		private store: Store<StateInterface>) {
	}

	/**
	 * Retrieve custom notifications data from server and dispatch action
	 * to update the store accordingly.
	 * @return {Observable}
	 */
	hydrateApplicationSettings(): Observable<Response> {
		this.store.dispatch(this.setIsLoading(true));
		return this.http.get(`${this.apiEndpoint}applicationsetting`, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Dispatch an action to load applicationsettings.
	 * @param {object} result
	 * @return {Actions}
	 */
	loadApplicationSettings(result: any): Actions {
		const { applicationsettings } = getState(this.store);

		return {
			type: ActionTypes.LOAD_APPLICATION_SETTINGS,
			payload: tassign(applicationsettings, {
				items: ItemsHelper.mapApplicationSettingItems(result),
				isLoading: false
			})
		};
	}

	/**
	 * Gets a single location by ID.
	 * @param {string} id
	 * @return {Observable<Response>}
	 */
	getApplicationSettingById(id: string): Observable<Response> {
		return this.http.get(`${this.apiEndpoint}applicationsetting/${id}`, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Gets the availability for a location by id.
	 * @param {string} id
	 * @return {Observable<Response>}
	 */
	patchApplicationSettingById(id: string, payload: any): Observable<Response> {
		return this.http.patch(`${this.apiEndpoint}applicationsetting/${id}`, payload, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Dispatch an action to reset the entire state.
	 * @return {Actions}
	 */
	resetState(): Actions {
		return {
			type: ActionTypes.RESET_STATE
		};
	}

	/**
	 * Dispatch an action to change the state for 'isLoading'.
	 * @param {boolean} to - The new state
	 * @return {Actions}
	 */
	setIsLoading(to: boolean): Actions {
		return {
			type: ActionTypes.SET_IS_LOADING,
			payload: to
		};
	}

}